import { render, staticRenderFns } from "./org-view.vue?vue&type=template&id=843dc6f6"
import script from "./org-view.vue?vue&type=script&lang=js"
export * from "./org-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports